import type { JSX } from 'react';
import { Badge } from '@/components/ui/badge';
import type { ExperienceVerificationStatus } from '@/features/experiences/types/experience.types';

type BadgeVariant = 'default' | 'secondary' | 'destructive' | 'outline';

const CONFIG: Record<ExperienceVerificationStatus, { label: string; variant: BadgeVariant }> = {
  DRAFT: { label: 'Draft', variant: 'secondary' },
  PENDING: { label: 'Pending', variant: 'outline' },
  VERIFIED: { label: 'Verified', variant: 'default' },
  REVIEW: { label: 'Requires review', variant: 'outline' },
  REJECTED: { label: 'Unable to verify', variant: 'destructive' },
};

export function ExperienceStatusBadge({
  status,
}: {
  status: ExperienceVerificationStatus;
}): JSX.Element {
  const { label, variant } = CONFIG[status];
  return <Badge variant={variant}>{label}</Badge>;
}
